module.exports = __webpack_public_path__ + "static/media/image21.67ad7b7b.JPG";